import {
  ApplicantOfferRequirement,
  DeepReadonly,
  IApplyUniConfigRequirement,
  OfferTaskLabel,
  UniConfigRequirementCategory,
  UniConfigRequirementTask
} from 'types';
import { deepFreeze } from '../utils/deepFreeze';

const applyUniCRequirements: IApplyUniConfigRequirement[] = [
  {
    id: 'Passport',
    enabled: true,
    type: UniConfigRequirementTask.Passport,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.Passport,
    conditions: { default: 'Please upload a copy of your passport' }
  },
  {
    id: 'PhotoID',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.PhotoID,
    conditions: {
      default:
        'Please upload your photographic proof of identity.  For example, this could be your Passport or National Identity Card.'
    }
  },
  {
    id: 'AcademicResults',
    enabled: true,
    type: UniConfigRequirementTask.AcademicResults,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.AcademicResults,
    conditions: {
      default: `Your offer is subject to meeting the academic entry requirement of {${ApplicantOfferRequirement.AcademicResults}}.`
    }
  },
  {
    id: 'AcademicCertificate',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.AcademicCertificate,
    conditions: {
      default:
        'Upload of academic certificate proving grades, if not in English, also upload the certified English translation'
    }
  },
  {
    id: 'AcademicTranscript',
    enabled: true,
    type: UniConfigRequirementTask.AcademicTranscript,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.AcademicTranscript,
    conditions: {
      default:
        'Upload of academic transcript proving grades, if not in English, also upload the certified English translation'
    }
  },
  {
    id: 'EnglishLanguageResults',
    enabled: true,
    type: UniConfigRequirementTask.EnglishLanguageResults,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.EnglishLanguageResults,
    conditions: {
      default: `Your offer is subject to meeting the English language requirement of {${ApplicantOfferRequirement.EnglishLanguageResults}}.`
    }
  },
  {
    id: 'EnglishLanguageCertificate',
    enabled: true,
    type: UniConfigRequirementTask.EnglishLanguageCertificate,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.EnglishLanguageCertificate,
    conditions: { default: 'Please upload your English Language Qualification or test results.' }
  },
  {
    id: 'CV',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.CV,
    conditions: { default: 'Please upload a current up to date CV to support your application' }
  },
  {
    id: 'ProofOfManagerialExperience',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.ProofOfManagerialExperience,
    conditions: { default: 'Please upload proof of your managerial experience' }
  },
  {
    id: 'ProofOfAddress',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.ProofOfAddress,
    conditions: { default: 'Please upload proof of your current address' }
  },
  {
    id: 'ProofOfImmigrationStatus',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.ProofOfImmigrationStatus,
    conditions: { default: 'Please upload proof of your UK immigration status' }
  },
  {
    id: 'LetterOfRecommendation',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.LetterOfRecommendation,
    conditions: { default: 'Please upload a letter of recommendation' }
  },
  {
    id: 'PersonalStatement',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.PersonalStatement,
    conditions: { default: 'Please upload a personal statement to support your application' }
  },
  {
    id: 'Portfolio',
    enabled: false,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.Portfolio,
    conditions: { default: 'Please upload a portfolio to support your application' }
  },
  {
    id: 'ProofOfNameChange',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.ProofOfNameChange,
    conditions: { default: 'Please upload evidence of the official document that confirm your change of name.' }
  },
  {
    id: 'NameAffidavit',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.NameAffidavit,
    conditions: { default: 'Please upload a name affidavit confirming your name change' }
  },
  {
    id: 'BirthCert',
    enabled: true,
    type: UniConfigRequirementTask.Upload,
    category: UniConfigRequirementCategory.System,
    label: OfferTaskLabel.BirthCert,
    conditions: { default: 'Please provide a birth or adoption certificate.' }
  }
];

export const defaultApplyUniConfigRequirement: DeepReadonly<IApplyUniConfigRequirement[]> =
  deepFreeze(applyUniCRequirements);
